import {
	categoryIdForStatusCategory,
	TODO,
} from '@atlassian/jira-common-constants/src/status-categories.tsx';
import { DEFAULT_CACHE_VARIABLES } from '../../../constants.tsx';

// An item is an issue if the issueId is a positive number
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isItemAnIssue = (issueId: any) => Number(issueId) > 0;

export const SKELETON_ITEM_PREFIX = 'SKELETON-ITEM-';

export const createItemSkeleton = ({ issueId }: { issueId: string }) => ({
	id: `${SKELETON_ITEM_PREFIX}${issueId}-id`,
	issueId: `${SKELETON_ITEM_PREFIX}${issueId}`,
	typeId: 'loading',
	issuetype: {},
	key: 'loading',
	rank: '',
	status: {
		name: 'To do',
		categoryId: categoryIdForStatusCategory(TODO).toString(),
	},
	totalSubtasks: 0,
	rankIndex: 0,
	cacheVariables: DEFAULT_CACHE_VARIABLES,
});

export const isItemSkeleton = (issueId = '') => String(issueId).startsWith(SKELETON_ITEM_PREFIX);

export const INLINE_CREATE_ITEM_PREFIX = 'INLINE-CREATE-';

export type InlineCreateType = 'task' | 'subtask' | 'group' | 'sibling';

export const createRowForInlineCreate = (
	type: InlineCreateType = 'subtask',
	issueId = 'InlineCreate',
) => ({
	id: `${INLINE_CREATE_ITEM_PREFIX}${type}-id`,
	issueId: `${INLINE_CREATE_ITEM_PREFIX}${type}-issueId`,
	parentIssueId: issueId,
	typeId: `${INLINE_CREATE_ITEM_PREFIX}-typeId--${issueId}`,
	issuetype: {},
	key: `${INLINE_CREATE_ITEM_PREFIX}-key-${issueId}`,
	rank: '',
	rankIndex: -1,
	status: {
		name: 'To do',
		categoryId: categoryIdForStatusCategory(TODO).toString(),
	},
	totalSubtasks: 0,
	rowKey: `${INLINE_CREATE_ITEM_PREFIX}-${issueId}`,
	cacheVariables: DEFAULT_CACHE_VARIABLES,
});

export const isItemAnInlineCreate = (issueId = '') => issueId.startsWith(INLINE_CREATE_ITEM_PREFIX);

export const isItemAnInlineCreateTask = (issueId = '') =>
	issueId.startsWith(`${INLINE_CREATE_ITEM_PREFIX}task`);

export const isItemAnInlineCreateSubTask = (issueId = '') =>
	issueId.startsWith(`${INLINE_CREATE_ITEM_PREFIX}subtask`);

export const isItemAnInlineCreateGroup = (issueId = '') =>
	issueId.startsWith(`${INLINE_CREATE_ITEM_PREFIX}group`);

export const isItemASiblingTopLevelHierarchyInlineCreate = (issueId = '') =>
	issueId.startsWith(`${INLINE_CREATE_ITEM_PREFIX}sibling`);

export const SHOW_MORE_ITEM_PREFIX = 'SHOW_MORE-';

export const isItemShowMore = (issueId = '') => issueId.startsWith(SHOW_MORE_ITEM_PREFIX);

export const createRowForShowMore = (issueId: string) => ({
	id: `${SHOW_MORE_ITEM_PREFIX}-id`,
	issueId: `${SHOW_MORE_ITEM_PREFIX}-issueId`,
	parentIssueId: issueId,
	typeId: `${SHOW_MORE_ITEM_PREFIX}-typeId--${issueId}`,
	issuetype: {},
	key: `${SHOW_MORE_ITEM_PREFIX}-key-${issueId}`,
	rank: '',
	rankIndex: -1,
	status: {
		name: 'To do',
		categoryId: categoryIdForStatusCategory(TODO).toString(),
	},
	totalSubtasks: 0,
	rowKey: `${SHOW_MORE_ITEM_PREFIX}-${issueId}`,
	cacheVariables: DEFAULT_CACHE_VARIABLES,
});
